/*
  Blocca l'aggiunta al carrello di varianti con prezzo 0 o scontate oltre il 99%
  (anomalie di listino).

  Intercetta /cart/add per coprire in un punto solo tutti i touchpoint: PDP,
  quick add PLP, wishlist e qualsiasi altro chiamante presente o futuro.
  Il controllo e' fatto sulla risposta e non prima della chiamata perche' quello
  e' l'unico punto in cui il prezzo arriva dal server invece che dal DOM: se la
  riga aggiunta ha prezzo 0 viene rimossa subito e al chiamante viene restituito
  un errore nello stesso formato usato da Shopify, cosi' le UI esistenti
  mostrano il messaggio senza modifiche.
*/
(function () {
  const ADD_URL = /\/cart\/add(\.js)?(\?|$)/;
  const originalFetch = window.fetch.bind(window);

  function changeUrl() {
    return (window.routes && window.routes.cart_change_url) || '/cart/change.js';
  }

  function errorMessage() {
    return (window.zeroPriceStrings && window.zeroPriceStrings.cartError) || 'Zero price item';
  }

  // Il gift wrapping e' un prodotto omaggio legittimo: resta escluso dal blocco.
  function isExempt(item) {
    return !!window.giftWrapVariantId && item.variant_id === window.giftWrapVariantId;
  }

  // La risposta di /cart/add non contiene il prezzo barrato: per le righe a
  // prezzo pieno lo si legge dal JSON prodotto, servito nella valuta del market.
  function compareAtPrice(item) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return originalFetch(`${root}products/${item.handle}.js`)
      .then((res) => res.json())
      .then((product) => {
        const variant = product.variants.find((v) => v.id === item.variant_id);
        return variant ? variant.compare_at_price : null;
      })
      .catch(() => null);
  }

  function anomalousLines(payload) {
    const items = payload && Array.isArray(payload.items) ? payload.items : [payload];
    const candidates = items.filter((item) => item && item.key && !isExempt(item));
    return Promise.all(
      candidates.map((item) =>
        item.price === 0
          ? true
          : compareAtPrice(item).then((compareAt) => window.isPriceAnomaly(item.price, compareAt))
      )
    ).then((flags) => candidates.filter((_, i) => flags[i]));
  }

  function removeLines(keys) {
    return keys.reduce(
      (chain, key) =>
        chain.then(() =>
          originalFetch(changeUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          })
        ),
      Promise.resolve()
    );
  }

  function rejectionResponse() {
    const message = errorMessage();
    return new Response(JSON.stringify({ status: 422, message: message, description: message }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const request = originalFetch(input, init);

    if (!ADD_URL.test(url)) return request;

    return request.then((response) => {
      if (!response.ok) return response;

      // La risposta non-JSON (POST form classico) non e' ispezionabile: in quel
      // caso il blocco resta a carico del carrello, che disabilita il checkout.
      return response
        .clone()
        .json()
        .then(
          (payload) =>
            anomalousLines(payload).then((lines) => {
              if (!lines.length) return response;

              console.warn('[zero-price-guard] rimosse righe con prezzo anomalo:', lines.map((l) => l.key));
              return removeLines(lines.map((line) => line.key)).then(rejectionResponse);
            }),
          () => response
        );
    });
  };
})();
